import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { CopySinkAdapter } from './copysink.adapter';
import { NativeMongoDbApiSink } from 'app/model/pipeline/copysink/native-mongo-db.copysink';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(NativeMongoDbApiSink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBehavior: '*',
        writeBatchSize: '*',
        writeBatchTimeout: '*'
    }
})
export class NativeMongoDbApiSinkAdapter extends CopySinkAdapter<NativeMongoDbApiSink, Model.NativeMongoDbSink> {
    protected override async _toResource(model: NativeMongoDbApiSink): Promise<Model.NativeMongoDbSink> {
        const result: Model.NativeMongoDbSink = {
            type: adfModelTypeMap.mongoDb.copySinkType
        };
        const writeBatchTimeout = ValueAdapter.toResource(model, NativeMongoDbApiSink.WRITE_BATCH_TIMEOUT);
        if (writeBatchTimeout != null && writeBatchTimeout !== '') {
            // don't need pass '' to backend
            result.writeBatchTimeout = writeBatchTimeout;
        }
        result.writeBatchSize = ValueAdapter.toResource(model, NativeMongoDbApiSink.WRITE_BATCH_SIZE);
        result.writeBehavior = ValueAdapter.toResource(model, NativeMongoDbApiSink.WRITE_BEHAVIOR);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(
        resource: Model.NativeMongoDbSink,
        owner: Activity
    ): Promise<NativeMongoDbApiSink> {
        const result = Owned.create<NativeMongoDbApiSink>(Metamodel.modelFor(NativeMongoDbApiSink), owner);
        ValueAdapter.toModel(result, NativeMongoDbApiSink.WRITE_BATCH_TIMEOUT, resource.writeBatchTimeout);
        ValueAdapter.toModel(result, NativeMongoDbApiSink.WRITE_BATCH_SIZE, resource.writeBatchSize);

        // handle upper case and lower case
        let writeBehavior = resource.writeBehavior;
        if (writeBehavior && typeof writeBehavior === 'string') {
            const lowerCaseValue = writeBehavior.toLowerCase();
            switch (lowerCaseValue) {
                case writeBehaviorOptionValues.insert:
                    writeBehavior = writeBehaviorOptionValues.insert;
                    break;
                case writeBehaviorOptionValues.upsert:
                    writeBehavior = writeBehaviorOptionValues.upsert;
                    break;
                default:
                    break;
            }
        }
        ValueAdapter.toModel(result, NativeMongoDbApiSink.WRITE_BEHAVIOR, writeBehavior);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
